const normalizeValue = (value) => {
    if (value === null || value === undefined || value === "") return null;

    if (Array.isArray(value)) {
        value = value.length ? value[0] : null;
    }

    const num = Number(value);
    return Number.isNaN(num) ? null : num;
};

const format = (value, decimals = null) => {
    if (value == null) return "N/A";
    return decimals !== null ? value.toFixed(decimals) : value;
};

const calculateVolume = (dx, dy, dz, decimals = null) => {
    if (dx == null || dy == null || dz == null) return null;
    const volume = dx * dy * dz;
    return decimals !== null ? Number(volume.toFixed(decimals)) : volume;
};

const DimensionsDisplay = ({ item, eleType = "span", showType = ["mm", "inch"] }) => {
    if (!item?.stagingPartsDataId) return null;
    const bbox = item.stagingPartsDataId;

    // Normalize values
    const bboxDx_mm = normalizeValue(bbox.bboxDx_mm);
    const bboxDy_mm = normalizeValue(bbox.bboxDy_mm);
    const bboxDz_mm = normalizeValue(bbox.bboxDz_mm);

    const bboxDx_in = normalizeValue(bbox.bboxDx_in);
    const bboxDy_in = normalizeValue(bbox.bboxDy_in);
    const bboxDz_in = normalizeValue(bbox.bboxDz_in);

    // Determine what should be shown
    const allowMM = showType?.includes("mm");
    const allowIN = showType?.includes("inch");

    const hasMM = allowMM && bboxDx_mm != null && bboxDy_mm != null && bboxDz_mm != null;
    const hasIN = allowIN && bboxDx_in != null && bboxDy_in != null && bboxDz_in != null;

    const volumeMm = hasMM ? calculateVolume(bboxDx_mm, bboxDy_mm, bboxDz_mm, 2) : null;
    const volumeIn = hasIN ? calculateVolume(bboxDx_in, bboxDy_in, bboxDz_in, 2) : null;

    const Content = (
        <>
            {/* Dimensions */}
            {hasMM && (
                <>
                    {format(bboxDx_mm)} x {format(bboxDy_mm)} x {format(bboxDz_mm)} (mm)
                </>
            )}

            {hasMM && hasIN && " / "}

            {hasIN && (
                <>
                    {format(bboxDx_in, 2)} x {format(bboxDy_in, 2)} x {format(bboxDz_in, 2)} (inch)
                </>
            )}

            {/* Volume */}
            {(hasMM || hasIN) && (
                <span className="block mt-1">
                    Volume:
                    {hasMM && <> {format(volumeMm, 2)} mm³</>}
                    {hasMM && hasIN && " / "}
                    {hasIN && <> {format(volumeIn, 2)} in³</>}
                </span>
            )}
        </>
    );

    if (eleType === "li") {
        return <li className="!text-[12px] text-gray-800">{Content}</li>;
    }

    return <span className="!text-[12px] text-gray-800">{Content}</span>;
};

export default DimensionsDisplay;
